/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Transporter } from '../../models/transporter';

export interface GetContentAttachment$Params {

/**
 * ID stránky
 */
  id: number;

/**
 * ID verzie
 */
  versionId: number;

/**
 * ID prílohy
 */
  attachmentId: number;
}

export function getContentAttachment(http: HttpClient, rootUrl: string, params: GetContentAttachment$Params, context?: HttpContext): Observable<StrictHttpResponse<Transporter>> {
  const rb = new RequestBuilder(rootUrl, getContentAttachment.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('versionId', params.versionId, {});
    rb.path('attachmentId', params.attachmentId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Transporter>;
    })
  );
}

getContentAttachment.PATH = '/admin/content/{id}/version/{versionId}/attachment/{attachmentId}';
